import { createFileRoute } from "@tanstack/react-router";
import { TrackingComponent } from "@/pages/tracking";
import { head, loader } from "@/pages/tracking.meta";

export const Route = createFileRoute("/$locale/tracking")({
  loader,
  head,
  component: TrackingComponent,
});
